export default __webpack_public_path__ + "static/media/office1-after2-480w.798cae9e.png";